import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Guards every nested route. Calls /api/auth/me on mount.
 * - 200 → render children
 * - 401 → <Navigate> to /login?next=<current>
 * - loading → splash
 */
export default function RequireAuth({ children }) {
  const [state, setState] = useState("loading"); // loading | ok | anon
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    api.get("/auth/me").then(
      () => { if (!cancelled) setState("ok"); },
      (err) => {
        if (cancelled) return;
        if (err?.response?.status === 401) setState("anon");
        else setState("ok"); // do not lock user out on transient 5xx
      }
    );
    return () => { cancelled = true; };
  }, []);

  if (state === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-500"
           data-testid="auth-loading">
        <span className="animate-pulse text-sm">Checking session…</span>
      </div>
    );
  }
  if (state === "anon") {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return children;
}
